module.exports = __webpack_public_path__ + "static/media/toward_mosca_morgan.01b09d8b.jpg";